module.exports = __webpack_public_path__ + "static/media/sweet_1.873182c5.png";